import PlanMakeTodoArea from "@/pages/comp/plan/todo/common/make_todo";

function MakeTodoPopup(props: any) {
  let myProps = {
    is_use_online_textbook: false,
    is_popup: true,
    closePopup: () => { },
    callbackData: (inData: any) => { },
    ...props
  };

  return (
    <div>
      <PlanMakeTodoArea
        is_use_online_textbook={myProps.is_use_online_textbook}
        closePopup={myProps.closePopup}
        callbackData={myProps.callbackData}
      ></PlanMakeTodoArea>
    </div>
  );
};
export default MakeTodoPopup;